import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { isEqual } from 'lodash-es';
import { navStore, pageTypeMapping, Tokens, TokensProvider, useStore, } from '@mcn-platform/models';
import DynamicPortal from './DynamicPortal';
// import TermsOfServiceModal from './TermsOfServiceModal';
// format is:
// /course/e98fd697-2c85-42a3-bf6f-7690b57656f9
export const parseRequestPath = (path) => {
    // drop any empty elements caused by leading, trailing or double slashes
    const elements = path.split('/').filter((e) => (e && e !== ''));
    const pageType = (elements.length === 0) ? 'home' : elements[0];
    const slugOrKey = (elements.length > 0) ? elements[1] : null;
    const modifiers = (elements.length > 1) ? elements.slice(1) : null;
    return {
        pageType,
        slugOrKey,
        modifiers,
    };
};
// format is:
// /portal/7620f912-ebdd-4289-b920-cc66f2f7d72e/course/e98fd697-2c85-42a3-bf6f-7690b57656f9
export const parseAdminRequestPath = (path) => {
    // console.log('parsing path', path);
    // in SSR the URL includes the querystring - so be sure to drop everything after the question mark
    // drop any empty elements caused by leading, trailing or double slashes
    const elements = path.split('?')[0].split('/').filter((e) => (e && e !== ''));
    const organizationId = elements[1];
    const portalId = elements[2];
    const pageType = (elements.length === 3) ? 'home' : elements[3];
    const slugOrKey = (elements.length > 3) ? elements[4] : null;
    const modifiers = (elements.length > 4) ? elements.slice(4) : null;
    return {
        organizationId,
        portalId,
        pageType,
        slugOrKey,
        modifiers,
    };
};
/**
 * PortalRouteMapper handles the routing for the path after the portal identification.
 * In other words it doesn't include /portal/orgId/portalId.
 * currentOrganization and currentPortal should be set on the store before it us used.
 */
const PortalRouteMapper = () => {
    //  const [cookies, setCookie] = useCookies(['TOS_Accepted']);
    const location = useLocation();
    const isPortalRuntime = !location.pathname.startsWith('/portal'); // ENV_PORTAL_ID && ENV_PORTAL_ID !== 'false';
    const { pageType, slugOrKey, modifiers, } = isPortalRuntime
        ? parseRequestPath(location.pathname)
        : parseAdminRequestPath(location.pathname);
    const [querystring] = useSearchParams();
    const store = useStore();
    const [activeObjectID, setActiveObjectID] = React.useState(store.getBySlug(pageTypeMapping[pageType], slugOrKey));
    const [activePageType, setActivePageType] = React.useState(pageType);
    const [activeModifiers, setActiveModifiers] = React.useState(modifiers);
    const [activeQuerystring, setActiveQuerystring] = React.useState(querystring);
    // console.log('Request is', {
    //   location,
    //   querystring,
    //   isServerSide,
    // });
    const { currentCustomer, currentAccess, currentPortal, currentOrganization, } = store;
    const organizationId = currentOrganization?.id;
    const portalId = currentPortal?.id;
    // console.log('PortalRouteMapper', {
    //   organizationId,
    //   portalId,
    //   currentCustomer,
    //   currentAccess,
    //   currentPortal,
    //   currentOrganization,
    // });
    const rootPath = isPortalRuntime ? '' : `/portal/${organizationId}/${portalId}`;
    // const handleClose = (value:Boolean) => {
    // setCookie('TOS_Accepted', value, {
    //   path: '/',
    // });
    // };
    // if (!cookies?.TOS_Accepted && model.properties.termsOfService.showTermsOfService) {
    //   return <TermsOfServiceModal portal={portal} handleClose={handleClose} />;
    // }
    const requestContext = {
        customer: currentCustomer || null,
        accessGroups: currentAccess?.groups,
    };
    useEffect(() => {
        const updateObjectID = (newValue) => {
            if (newValue !== activeObjectID) {
                setActiveObjectID(newValue);
            }
        };
        const updatePageType = (newValue) => {
            if (newValue !== activePageType) {
                setActivePageType(newValue);
            }
        };
        const updateModifiers = (newValue) => {
            if (!isEqual(newValue, activeModifiers)) {
                setActiveModifiers(newValue);
            }
        };
        const updateQuerystring = (newValue) => {
            if (newValue !== activeQuerystring) {
                setActiveQuerystring(newValue);
            }
        };
        const doRouting = async () => {
            navStore.showBlockInput();
            const objectID = await store.searchBySlug(pageTypeMapping[pageType], slugOrKey);
            updatePageType(pageType);
            updateObjectID(objectID);
            updateModifiers(modifiers);
            updateQuerystring(querystring);
            navStore.clearBlockInput();
        };
        // if we have the id from the slug just use it
        const idFromSlug = store.getBySlug(pageTypeMapping[pageType], slugOrKey);
        if (idFromSlug) {
            updateObjectID(idFromSlug);
            updatePageType(pageType);
            updateModifiers(modifiers);
            updateQuerystring(querystring);
        }
        else {
            doRouting();
        }
    });
    return (_jsx(TokensProvider, { value: new Tokens(currentPortal), children: _jsx(DynamicPortal, { rootPath: rootPath, portal: currentPortal, pageType: activePageType, objectId: activeObjectID, modifiers: activeModifiers, querystring: activeQuerystring, requestContext: requestContext, doPreload: false }) }));
};
export default observer(PortalRouteMapper);
//# sourceMappingURL=PortalRouteMapper.js.map